/* Haşimi — mega menü: Taşlar foto carousel + Mücevher MM-tarzı kolonlar
   i18n: TR/EN üçlüleri korunur; RU/AR gömülü sözlüklerden gelir (megamenu-i18n-ru/ar.json). */
(function () {
  var LOCALE = (document.documentElement.lang || 'tr').split('-')[0].toLowerCase();
  if (LOCALE !== 'en' && LOCALE !== 'ru' && LOCALE !== 'ar') LOCALE = 'tr';
  var EN = LOCALE === 'en';

  /* RU/AR sözlükleri — megamenu-i18n-ru.json / megamenu-i18n-ar.json içerikleri gömülü (fetch yok) */
  var I18N_RU = {"MUC_COLS":[{"h":"Категории","links":[["Все украшения","/collections/tum-mucevherler"],["Кольца","/collections/yuzuk"],["Колье","/collections/kolye"],["Серьги","/collections/kupe"],["Браслеты","/collections/bileklik"],["Комплекты","/collections/set"],["Чётки","/collections/tesbih"]]},{"h":"Коллекции","links":[["Новинки","/collections/yeni"],["Хиты продаж","/collections/cok-satanlar"],["Избранное","/collections/one-cikanlar"],["Для неё","/collections/kadin-koleksiyon"],["Для него","/collections/erkek-koleksiyon"],["Выбор Hashimi","/collections/secilmisler"]]},{"h":"Намерения","links":[["Защита","/collections/niyet-koruma"],["Любовь и преданность","/collections/niyet-sevgi"],["Равновесие и покой","/collections/niyet-denge-huzur"],["Изобилие и достаток","/collections/niyet-bolluk"],["Смелость и сила","/collections/niyet-cesaret"],["Интуиция и ясность","/collections/niyet-sezgi"],["Фокус и концентрация","/collections/niyet-odak"]]}],"HIK_DESC":{"/pages/hakkimizda":"Всё началось с ученика — история длиной в тридцать лет","/pages/bakim-rehberi":"Как продлить жизнь твоему камню","/blogs/rehber":"Гиды и статьи из мира камней","/pages/iletisim":"Мы рядом, если есть вопросы","/pages/contact":"Мы рядом, если есть вопросы"},"BURC":[["koc","Овен","♈","21 марта – 20 апреля"],["boga","Телец","♉","21 апреля – 20 мая"],["ikizler","Близнецы","♊","21 мая – 21 июня"],["yengec","Рак","♋","22 июня – 22 июля"],["aslan","Лев","♌","23 июля – 23 августа"],["basak","Дева","♍","24 августа – 22 сентября"],["terazi","Весы","♎","23 сентября – 23 октября"],["akrep","Скорпион","♏","24 октября – 22 ноября"],["yay","Стрелец","♐","23 ноября – 21 декабря"],["oglak","Козерог","♑","22 декабря – 20 января"],["kova","Водолей","♒","21 января – 18 февраля"],["balik","Рыбы","♓","19 февраля – 20 марта"]],"ui":{"Haşimi atölyesi — otuz yıllık usta eli":"Мастерская Hashimi — тридцать лет руки мастера","Otuz Yıllık Usta Eli":"Тридцать лет руки мастера","Hikayemizi oku":"Читать нашу историю","Sonraki görsel":"Следующее изображение","Önceki görsel":"Предыдущее изображение"}};
  var I18N_AR = {"MUC_COLS":[{"h":"الفئات","links":[["كل المجوهرات","/collections/tum-mucevherler"],["خواتم","/collections/yuzuk"],["قلادات","/collections/kolye"],["أقراط","/collections/kupe"],["أساور","/collections/bileklik"],["أطقم مجوهرات","/collections/set"],["مسابح","/collections/tesbih"]]},{"h":"المجموعات","links":[["وصل حديثًا","/collections/yeni"],["الأكثر مبيعًا","/collections/cok-satanlar"],["الأبرز","/collections/one-cikanlar"],["لها","/collections/kadin-koleksiyon"],["له","/collections/erkek-koleksiyon"],["مختارات هاشمي","/collections/secilmisler"]]},{"h":"النوايا","links":[["الحماية","/collections/niyet-koruma"],["الحب والوفاء","/collections/niyet-sevgi"],["التوازن والسكينة","/collections/niyet-denge-huzur"],["الوفرة والبركة","/collections/niyet-bolluk"],["الشجاعة والقوة","/collections/niyet-cesaret"],["الحدس والصفاء","/collections/niyet-sezgi"],["التركيز والوضوح","/collections/niyet-odak"]]}],"HIK_DESC":{"/pages/hakkimizda":"بدأت الحكاية بصبي متدرب — قصة ثلاثين عامًا","/pages/bakim-rehberi":"كيف تحافظ على حجرك لسنوات طويلة","/blogs/rehber":"أدلة وقراءات من عالم الأحجار","/pages/iletisim":"نحن هنا لأسئلتكم","/pages/contact":"نحن هنا لأسئلتكم"},"BURC":[["koc","الحمل","♈","21 مارس – 20 أبريل"],["boga","الثور","♉","21 أبريل – 20 مايو"],["ikizler","الجوزاء","♊","21 مايو – 21 يونيو"],["yengec","السرطان","♋","22 يونيو – 22 يوليو"],["aslan","الأسد","♌","23 يوليو – 23 أغسطس"],["basak","العذراء","♍","24 أغسطس – 22 سبتمبر"],["terazi","الميزان","♎","23 سبتمبر – 23 أكتوبر"],["akrep","العقرب","♏","24 أكتوبر – 22 نوفمبر"],["yay","القوس","♐","23 نوفمبر – 21 ديسمبر"],["oglak","الجدي","♑","22 ديسمبر – 20 يناير"],["kova","الدلو","♒","21 يناير – 18 فبراير"],["balik","الحوت","♓","19 فبراير – 20 مارس"]],"ui":{"Haşimi atölyesi — otuz yıllık usta eli":"ورشة هاشمي — ثلاثون عامًا من يد المعلّم","Otuz Yıllık Usta Eli":"ثلاثون عامًا من يد المعلّم","Hikayemizi oku":"اقرأ حكايتنا","Sonraki görsel":"الصورة التالية","Önceki görsel":"الصورة السابقة"}};
  var L = LOCALE === 'ru' ? I18N_RU : (LOCALE === 'ar' ? I18N_AR : null);
  /* T: önce locale sözlüğü (ui, TR metin anahtarlı), yoksa eski EN?en:tr davranışı */
  function T(tr, en) {
    if (L && L.ui && Object.prototype.hasOwnProperty.call(L.ui, tr)) return L.ui[tr];
    return EN ? en : tr;
  }

  /* ══ MÜCEVHER paneli — KADIN | ERKEK iki sütun (2026-08-31, Görev 3) ══
     11 link: 5 kadın + 4 erkek + 2 sütun başlığı … + alt satır "Tüm Mücevherler".
     Etiketler 4 dilde; koleksiyon handle'ları dile göre değişmez, yol öneki
     (/en, /ru, /ar) probe'un href'inden alınır (buildTaslar deseni). */
  var MUC_G_L10N = {
    tr: { kadin:'Kadın', erkek:'Erkek', yuzuk:'Yüzük', kolye:'Kolye', kupe:'Küpe',
          bileklik:'Bileklik', set:'Takı Seti', tesbih:'Tesbih',
          all:'Tüm Mücevherler', cta:'Keşfet' },
    en: { kadin:'Women', erkek:'Men', yuzuk:'Rings', kolye:'Necklaces', kupe:'Earrings',
          bileklik:'Bracelets', set:'Jewellery Sets', tesbih:'Prayer Beads',
          all:'All Jewellery', cta:'Explore' },
    ru: { kadin:'Женщинам', erkek:'Мужчинам', yuzuk:'Кольца', kolye:'Колье', kupe:'Серьги',
          bileklik:'Браслеты', set:'Комплекты', tesbih:'Чётки',
          all:'Все украшения', cta:'Смотреть' },
    ar: { kadin:'للنساء', erkek:'للرجال', yuzuk:'خواتم', kolye:'قلائد', kupe:'أقراط',
          bileklik:'أساور', set:'أطقم', tesbih:'مسابح',
          all:'كل المجوهرات', cta:'اكتشف' }
  };
  var G = MUC_G_L10N[LOCALE] || MUC_G_L10N.tr;

  /* sütun tanımı: [gender, başlık anahtarı, başlık handle, [[etiket anahtarı, handle], …]] */
  var MUC_G = [
    { g:'kadin', label:G.kadin, handle:'kadin-koleksiyon', links:[
      [G.yuzuk,    'kadin-yuzuk'],
      [G.kolye,    'kadin-kolye'],
      [G.kupe,     'kadin-kupe'],
      [G.bileklik, 'kadin-bileklik'],
      [G.set,      'kadin-set']
    ]},
    { g:'erkek', label:G.erkek, handle:'erkek-koleksiyon', links:[
      [G.yuzuk,    'erkek-yuzuk'],
      [G.kolye,    'erkek-kolye'],
      [G.bileklik, 'erkek-bileklik'],
      [G.tesbih,   'tesbih']
    ]}
  ];
  var MUC_ALL_HANDLE = 'tum-mucevherler';
  var MUC_IMG = {
    kadin: 'https://cdn.shopify.com/s/files/1/0608/2350/2912/t/6/assets/hasimi-nav-kadin.jpg',
    erkek: 'https://cdn.shopify.com/s/files/1/0608/2350/2912/t/6/assets/hasimi-nav-erkek.jpg'
  };

  /* Panel tetikleyicileri — TEK bir linke bağlı kalmasın diye geniş liste.
     Menüden /collections/yuzuk kalksa bile paneli kuran başka bir eşleşme kalır. */
  var MUC_PROBES = [
    '/collections/yuzuk', '/collections/kolye', '/collections/kupe', '/collections/bileklik',
    '/collections/set', '/collections/tesbih', '/collections/tum-mucevherler',
    '/collections/kadin-koleksiyon', '/collections/erkek-koleksiyon',
    '/collections/kadin-yuzuk', '/collections/erkek-yuzuk'
  ];
  /* Bu paneller Mücevher DEĞİL — yanlışlıkla ezmeyi engelleyen dışlamalar */
  var MUC_EXCLUDE = 'a[href*="/collections/ametist-tasi"], a[href*="/collections/burc-koc"], a[href*="/pages/hakkimizda"]';

  /* Not: 2026-08-31 öncesi 3 sütunlu içerik (Kategoriler/Koleksiyonlar/Niyetler)
     bu noktadaydı; KADIN|ERKEK düzenine geçildi. Eski dizi:
     SP/nav_yedek/pre-task3/assets/hasimi-mega-menu.js (satır 19-74). */

  function buildMucevher() {
    // hem desktop hem mobil klon: içinde mücevher kategori linki olan tier-2 ul'lar
    document.querySelectorAll('ul.navigation__tier-2').forEach(function (ul) {
      if (ul.dataset.hmMuc) return;
      // Taşlar / Burç / Hikaye panellerine dokunma
      if (ul.dataset.hmTas || ul.dataset.hmBurc || ul.dataset.hmHik) return;
      if (ul.querySelector(MUC_EXCLUDE)) return;
      // çoklu probe: listedeki handle'lardan HERHANGİ biri yeterli
      var probe = null;
      var cands = ul.querySelectorAll(':scope > li > a[href*="/collections/"]');
      for (var i = 0; i < cands.length && !probe; i++) {
        var h = (cands[i].getAttribute('href') || '').split('?')[0].replace(/\/$/, '');
        for (var j = 0; j < MUC_PROBES.length; j++) {
          if (h.length >= MUC_PROBES[j].length && h.slice(-MUC_PROBES[j].length) === MUC_PROBES[j]) { probe = cands[i]; break; }
        }
      }
      if (!probe) return;
      ul.dataset.hmMuc = '1';

      /* dil yolu öneki (/en, /ru, /ar …) — buildTaslar deseni */
      var ph = probe.getAttribute('href') || '';
      var prefix = ph.slice(0, ph.indexOf('/collections/'));
      function url(handle) { return prefix + '/collections/' + handle; }

      ul.innerHTML = '';   /* tema promoları burada düşer; sağ görsel aşağıda kurulur */

      /* ── iki cinsiyet sütunu + alt "Tümü" satırı ── */
      var wrap = document.createElement('li');
      wrap.className = 'hm-col hm-gwrap';
      var cols = document.createElement('div');
      cols.className = 'hm-gcols';
      MUC_G.forEach(function (col) {
        var d = document.createElement('div');
        d.className = 'hm-g';
        d.setAttribute('data-hm-gender', col.g);
        var head = document.createElement('a');
        head.className = 'hm-h hm-gh';
        head.href = url(col.handle);
        head.textContent = col.label;
        d.appendChild(head);
        col.links.forEach(function (l) {
          var a = document.createElement('a');
          a.className = 'hm-l';
          a.href = url(l[1]);
          a.textContent = l[0];
          d.appendChild(a);
        });
        cols.appendChild(d);
      });
      wrap.appendChild(cols);

      var all = document.createElement('a');
      all.className = 'hm-all';
      all.href = url(MUC_ALL_HANDLE);
      all.appendChild(document.createTextNode(G.all));
      var ar = document.createElement('span');
      ar.className = 'hm-ar';
      ar.textContent = '→';
      all.appendChild(ar);
      wrap.appendChild(all);
      ul.appendChild(wrap);

      /* ── sağda cinsiyete göre değişen görsel (Hikaye hm-simg deseni) ──
         Görev 3 düzeltme turu (2026-08-31):
         - mobilde panel CSS ile gizli olsa da tam boyut JPEG inmesin diye
           srcset (560/920/1120w) + sizes="…,1px" + loading=lazy;
         - gizli katman klavye/screen-reader'a görünmesin diye aria-hidden + tabindex=-1,
           hover/focus geçişinde görünen katmandan bu öznitelikler kaldırılır;
         - alt metin görünür "KADIN/ERKEK KEŞFET" ile tekrar etmesin diye alt=""  */
      var vis = document.createElement('li');
      vis.className = 'hm-gimg';
      var layers = {};
      function setGenderLayer(activeG) {
        Object.keys(layers).forEach(function (k) {
          var el = layers[k];
          var on = k === activeG;
          el.classList.toggle('hm-on', on);
          if (on) {
            el.removeAttribute('aria-hidden');
            el.removeAttribute('tabindex');
          } else {
            el.setAttribute('aria-hidden', 'true');
            el.setAttribute('tabindex', '-1');
          }
        });
      }
      MUC_G.forEach(function (col, idx) {
        var a = document.createElement('a');
        a.className = 'hm-gi hm-gi--' + col.g + (idx === 0 ? ' hm-on' : '');
        a.href = url(col.handle);
        var img = document.createElement('img');
        var src560 = MUC_IMG[col.g] + '?width=560';
        var src920 = MUC_IMG[col.g] + '?width=920';
        var src1120 = MUC_IMG[col.g] + '?width=1120';
        img.src = src1120;
        img.srcset = src560 + ' 560w, ' + src920 + ' 920w, ' + src1120 + ' 1120w';
        img.sizes = '(min-width:1120px) 460px, 1px';
        img.alt = '';
        img.loading = 'lazy'; img.decoding = 'async';
        a.appendChild(img);
        var st = document.createElement('span');
        st.className = 'hm-gt';
        st.appendChild(document.createTextNode(col.label));
        var em = document.createElement('em');
        em.textContent = G.cta;
        st.appendChild(em);
        a.appendChild(st);
        vis.appendChild(a);
        layers[col.g] = a;
      });
      ul.appendChild(vis);
      /* başlangıç durumu: idx 0 (kadın) görünür, diğerleri gizli */
      setGenderLayer(MUC_G[0].g);

      /* hover/focus: sütuna girince o cinsiyetin görseli öne geçer, aria-hidden/tabindex birlikte toggle olur */
      wrap.querySelectorAll('[data-hm-gender]').forEach(function (d) {
        var g = d.getAttribute('data-hm-gender');
        d.addEventListener('mouseenter', function () { setGenderLayer(g); });
        d.addEventListener('focusin', function () { setGenderLayer(g); });
      });
    });
  }

  /* Tema markup'ından geri konan bloklardaki (promo li'leri) kök-göreli
     linklere dil önekini ekler. Zaten önekli / mutlak / hash / mailto
     linklere dokunmaz; TR'de (prefix '') hiç çalışmaz. */
  function localizeHrefs(scope, prefix) {
    if (!scope || !prefix) return;
    scope.querySelectorAll('a[href]').forEach(function (a) {
      var h = a.getAttribute('href') || '';
      if (h.charAt(0) !== '/' || h.charAt(1) === '/') return;      /* kök-göreli değil */
      if (h === prefix || h.indexOf(prefix + '/') === 0) return;   /* zaten önekli */
      a.setAttribute('href', prefix + h);
    });
  }

  /* ── Hikaye paneli: açıklamalı linkler + usta fotoğrafı ── */
  var HIK_DESC = EN ? {
    '/pages/hakkimizda': 'It began with an apprentice — a thirty-year story',
    '/pages/bakim-rehberi': 'How to make your stone last',
    '/blogs/rehber': 'Guides from the world of stones',
    '/pages/iletisim': 'We are here for your questions',
    '/pages/contact': 'We are here for your questions'
  } : {
    '/pages/hakkimizda': 'Bir çırakla başladı — otuz yıllık hikâye',
    '/pages/bakim-rehberi': 'Taşının ömrünü uzatmanın yolları',
    '/blogs/rehber': 'Taş dünyasından rehber yazılar',
    '/pages/iletisim': 'Sorularınız için buradayız',
    '/pages/contact': 'Sorularınız için buradayız'
  };
  if (L && L.HIK_DESC) HIK_DESC = L.HIK_DESC;

  function buildHikaye() {
    document.querySelectorAll('ul.navigation__tier-2').forEach(function (ul) {
      if (ul.dataset.hmHik) return;
      if (!ul.querySelector('a[href$="/pages/hakkimizda"]')) return;
      if (ul.querySelector('.hm-col, .hm-gwrap, .hm-zcol, a[href$="/collections/ametist-tasi"]')) return;
      ul.dataset.hmHik = '1';
      /* dil yolu öneki — ul temizlenmeden ÖNCE alınır (aynı disiplin: buildBurc/buildTaslar) */
      var prefix = navPrefix(ul);
      // mevcut linkleri (href'leriyle) koru
      var links = [].slice.call(ul.querySelectorAll('a')).map(function (a) {
        return { t: a.textContent.trim(), h: a.getAttribute('href') };
      }).filter(function (l) { return l.t && l.h; });
      ul.innerHTML = '';
      var li = document.createElement('li');
      li.className = 'hm-scol';
      links.forEach(function (l) {
        var a = document.createElement('a');
        a.className = 'hm-s';
        a.href = l.h;
        var n = document.createElement('span');
        n.className = 'hm-sn';
        n.textContent = l.t;
        a.appendChild(n);
        var hk=Object.keys(HIK_DESC).find(function(k){return l.h && l.h.indexOf(k)>-1;});
        if (hk) {
          var d = document.createElement('span');
          d.className = 'hm-sd';
          d.textContent = HIK_DESC[hk];
          a.appendChild(d);
        }
        li.appendChild(a);
      });
      ul.appendChild(li);
      // sağda usta fotoğrafı
      var stMain = L ? T('Otuz Yıllık Usta Eli','') : (EN ? 'Thirty Years of a Master\'s Hand' : 'Otuz Yıllık Usta Eli');
      var stSub = T('Hikayemizi oku','Read our story');
      var pi = document.createElement('li');
      pi.className = 'hm-simg';
      var pa = document.createElement('a');
      pa.href = prefix + '/pages/hakkimizda';   /* dil öneki eksikti — /en /ru /ar'da TR sayfasına düşüyordu */
      var pimg = document.createElement('img');
      pimg.src = 'https://cdn.shopify.com/s/files/1/0608/2350/2912/files/hasimi-v10-story-usta.jpg?width=920';
      pimg.alt = T('Haşimi atölyesi — otuz yıllık usta eli','Haşimi atelier — thirty years of a master\'s hand');
      pimg.loading = 'lazy'; pimg.decoding = 'async';   /* 2026-09-28: kapalı menüde inmesin; menü açılınca yüklenir */
      var pst = document.createElement('span');
      pst.className = 'hm-st';
      pst.appendChild(document.createTextNode(stMain));
      var pem = document.createElement('em');
      pem.textContent = stSub;
      pst.appendChild(pem);
      pa.appendChild(pimg);
      pa.appendChild(pst);
      pi.appendChild(pa);
      ul.appendChild(pi);
    });
  }

  /* ── Burcuna göre paneli: zodyak ikonları + kanonik tarihler ── */
  var BURC = EN ? [
    ['koc',     'Aries',       '♈', '21 March – 20 April'],
    ['boga',    'Taurus',      '♉', '21 April – 20 May'],
    ['ikizler', 'Gemini',      '♊', '21 May – 21 June'],
    ['yengec',  'Cancer',      '♋', '22 June – 22 July'],
    ['aslan',   'Leo',         '♌', '23 July – 23 August'],
    ['basak',   'Virgo',       '♍', '24 August – 22 September'],
    ['terazi',  'Libra',       '♎', '23 September – 23 October'],
    ['akrep',   'Scorpio',     '♏', '24 October – 22 November'],
    ['yay',     'Sagittarius', '♐', '23 November – 21 December'],
    ['oglak',   'Capricorn',   '♑', '22 December – 20 January'],
    ['kova',    'Aquarius',    '♒', '21 January – 18 February'],
    ['balik',   'Pisces',      '♓', '19 February – 20 March']
  ] : [
    ['koc',     'Koç',     '♈', '21 Mart – 20 Nisan'],
    ['boga',    'Boğa',    '♉', '21 Nisan – 20 Mayıs'],
    ['ikizler', 'İkizler', '♊', '21 Mayıs – 21 Haziran'],
    ['yengec',  'Yengeç',  '♋', '22 Haziran – 22 Temmuz'],
    ['aslan',   'Aslan',   '♌', '23 Temmuz – 23 Ağustos'],
    ['basak',   'Başak',   '♍', '24 Ağustos – 22 Eylül'],
    ['terazi',  'Terazi',  '♎', '23 Eylül – 23 Ekim'],
    ['akrep',   'Akrep',   '♏', '24 Ekim – 22 Kasım'],
    ['yay',     'Yay',     '♐', '23 Kasım – 21 Aralık'],
    ['oglak',   'Oğlak',   '♑', '22 Aralık – 20 Ocak'],
    ['kova',    'Kova',    '♒', '21 Ocak – 18 Şubat'],
    ['balik',   'Balık',   '♓', '19 Şubat – 20 Mart']
  ];
  if (L && L.BURC) BURC = L.BURC;

  function buildBurc() {
    document.querySelectorAll('ul.navigation__tier-2').forEach(function (ul) {
      if (ul.dataset.hmBurc) return;
      if (!ul.querySelector('a[href$="/collections/burc-koc"]')) return;
      ul.dataset.hmBurc = '1';
      /* dil yolu öneki — ul temizlenmeden ÖNCE alınır (navPrefix yedek yolu
         panel içi bir /collections/ linkine bakar). TR'de '' döner. */
      var prefix = navPrefix(ul);
      var promos = [].slice.call(ul.querySelectorAll(':scope > li.navigation__column--promotion'));
      ul.innerHTML = '';
      var li = document.createElement('li');
      li.className = 'hm-zcol';
      BURC.forEach(function (b) {
        var a = document.createElement('a');
        a.className = 'hm-z';
        a.href = prefix + '/collections/burc-' + b[0];
        var ic = document.createElement('span');
        ic.className = 'hm-zi';
        ic.textContent = b[2] + '︎'; /* VS15: text stili, emoji değil */
        var nm = document.createElement('span');
        nm.className = 'hm-zn';
        nm.textContent = b[1];
        var dt = document.createElement('span');
        dt.className = 'hm-zd';
        dt.textContent = b[3];
        a.appendChild(ic); a.appendChild(nm); a.appendChild(dt);
        li.appendChild(a);
      });
      ul.appendChild(li);
      promos.forEach(function (p) {
        p.classList.add('hm-zp');
        localizeHrefs(p, prefix);   /* tema promo linkleri kök-göreli gelir → dil öneki ekle */
        /* 2026-09-28: kapalı menü görseli sayfa açılışında inmesin (satır ~171 kalıbı: lazy + mobilde 1px) */
        p.querySelectorAll('img').forEach(function (img) { img.loading = 'lazy'; img.sizes = '(min-width: 990px) 490px, 1px'; });
        ul.appendChild(p);
      });
    });
  }


  /* ══ TAŞINA GÖRE paneli (v3) — gerçek taş fotoğrafı vinyetleri ══
     Taş listesi burada tanımlıdır; Shopify navigasyonundaki ham liste
     yeniden kurulur. Ad çevirisi varsa DOM'daki (Shopify Translate)
     metin korunur, yoksa aşağıdaki sözlükten gelir. */
  var TAS_CDN = "https://cdn.shopify.com/s/files/1/0608/2350/2912/files/hasimi-tas-v3-";
  var TAS = [["yakut", "yakut-tasi", "Yakut", "Cesaret"], ["elmas", "elmas-tasi", "Elmas", "Berraklık"], ["kuvars", "kuvars-tasi", "Kuvars", "Arınma"], ["turmalin", "turmalin-tasi", "Turmalin", "Denge"], ["ametist", "ametist-tasi", "Ametist", "İç Huzur"], ["safir", "safir-tasi", "Safir", "Sezgi"], ["zumrut", "zumrut-tasi", "Zümrüt", "Sevgi"], ["inci", "inci-tasi", "İnci", "Saflık"], ["aytasi", "aytasi-tasi", "Aytaşı", "Uyum"], ["akik", "akik-tasi", "Akik", "Bereket"], ["akuamarin", "akuamarin-tasi", "Akuamarin", "Dinginlik"], ["firuze", "firuze-tasi", "Firuze", "Koruma"], ["labradorit", "labradorit-tasi", "Labradorit", "Işık"], ["garnet", "garnet-tasi", "Garnet", "Kararlılık"], ["sitrin", "sitrin-tasi", "Sitrin", "Bolluk"], ["mercan", "mercan-tasi", "Mercan", "Canlılık"], ["opal", "opal-tasi", "Opal", "Dönüşüm"], ["kyanit", "kyanit-tasi", "Kyanit", "Sükunet"], ["peridot", "peridot-tasi", "Peridot", "Yenilenme"], ["topaz", "topaz-tasi", "Topaz", "Güven"], ["kehribar", "kehribar-tasi", "Kehribar", "Sıcaklık"], ["lapis", "lapis-lazuli-tasi", "Lapis Lazuli", "İfade"]];
  var TAS_L10N = { en: {"yakut-tasi": ["Ruby", "Courage"], "elmas-tasi": ["Diamond", "Clarity"], "kuvars-tasi": ["Quartz", "Cleansing"], "turmalin-tasi": ["Tourmaline", "Balance"], "ametist-tasi": ["Amethyst", "Inner Peace"], "safir-tasi": ["Sapphire", "Intuition"], "zumrut-tasi": ["Emerald", "Love"], "inci-tasi": ["Pearl", "Purity"], "aytasi-tasi": ["Moonstone", "Harmony"], "akik-tasi": ["Agate", "Abundance"], "akuamarin-tasi": ["Aquamarine", "Serenity"], "firuze-tasi": ["Turquoise", "Protection"], "labradorit-tasi": ["Labradorite", "Light"], "garnet-tasi": ["Garnet", "Resolve"], "sitrin-tasi": ["Citrine", "Prosperity"], "mercan-tasi": ["Coral", "Vitality"], "opal-tasi": ["Opal", "Transformation"], "kyanit-tasi": ["Kyanite", "Calm"], "peridot-tasi": ["Peridot", "Renewal"], "topaz-tasi": ["Topaz", "Confidence"], "kehribar-tasi": ["Amber", "Warmth"], "lapis-lazuli-tasi": ["Lapis Lazuli", "Expression"]}, ru: {"yakut-tasi": ["Рубин", "Смелость"], "elmas-tasi": ["Бриллиант", "Ясность"], "kuvars-tasi": ["Кварц", "Очищение"], "turmalin-tasi": ["Турмалин", "Равновесие"], "ametist-tasi": ["Аметист", "Внутренний покой"], "safir-tasi": ["Сапфир", "Интуиция"], "zumrut-tasi": ["Изумруд", "Любовь"], "inci-tasi": ["Жемчуг", "Чистота"], "aytasi-tasi": ["Лунный камень", "Гармония"], "akik-tasi": ["Агат", "Изобилие"], "akuamarin-tasi": ["Аквамарин", "Безмятежность"], "firuze-tasi": ["Бирюза", "Защита"], "labradorit-tasi": ["Лабрадорит", "Свет"], "garnet-tasi": ["Гранат", "Решимость"], "sitrin-tasi": ["Цитрин", "Достаток"], "mercan-tasi": ["Коралл", "Жизненная сила"], "opal-tasi": ["Опал", "Преображение"], "kyanit-tasi": ["Кианит", "Спокойствие"], "peridot-tasi": ["Перидот", "Обновление"], "topaz-tasi": ["Топаз", "Уверенность"], "kehribar-tasi": ["Янтарь", "Тепло"], "lapis-lazuli-tasi": ["Лазурит", "Самовыражение"]}, ar: {"yakut-tasi": ["الياقوت", "الشجاعة"], "elmas-tasi": ["الألماس", "الصفاء"], "kuvars-tasi": ["الكوارتز", "التطهير"], "turmalin-tasi": ["التورمالين", "التوازن"], "ametist-tasi": ["الجمشت", "السكينة"], "safir-tasi": ["الياقوت الأزرق", "الحدس"], "zumrut-tasi": ["الزمرد", "المحبة"], "inci-tasi": ["اللؤلؤ", "النقاء"], "aytasi-tasi": ["حجر القمر", "الانسجام"], "akik-tasi": ["العقيق", "البركة"], "akuamarin-tasi": ["الأكوامارين", "الطمأنينة"], "firuze-tasi": ["الفيروز", "الحماية"], "labradorit-tasi": ["اللابرادوريت", "النور"], "garnet-tasi": ["الغارنت", "العزيمة"], "sitrin-tasi": ["السيترين", "الوفرة"], "mercan-tasi": ["المرجان", "الحيوية"], "opal-tasi": ["الأوبال", "التحوّل"], "kyanit-tasi": ["الكيانيت", "الهدوء"], "peridot-tasi": ["الزبرجد", "التجدد"], "topaz-tasi": ["التوباز", "الثقة"], "kehribar-tasi": ["الكهرمان", "الدفء"], "lapis-lazuli-tasi": ["اللازورد", "التعبير"]} };

  function buildTaslar() {
    var dict = TAS_L10N[LOCALE] || null;
    document.querySelectorAll('ul.navigation__tier-2').forEach(function (ul) {
      if (ul.dataset.hmTas) return;
      var probe = ul.querySelector(':scope > li > a[href$="/collections/ametist-tasi"]');
      if (!probe) return;
      ul.dataset.hmTas = '1';

      /* dil ön eki (/en, /ru, /ar …) ve mevcut çeviri metinleri */
      var href = probe.getAttribute('href') || '';
      var prefix = href.slice(0, href.indexOf('/collections/'));
      var seen = {};
      ul.querySelectorAll(':scope > li > a[href*="/collections/"]').forEach(function (a) {
        var h = (a.getAttribute('href') || '').split('?')[0].replace(/\/$/, '');
        var k = h.slice(h.lastIndexOf('/') + 1);
        var t = (a.textContent || '').trim();
        if (k && t && !seen[k]) seen[k] = t;
      });

      var promos = [].slice.call(ul.querySelectorAll(':scope > li.navigation__column--promotion'));
      ul.innerHTML = '';

      var li = document.createElement('li');
      li.className = 'hm-tcol';
      TAS.forEach(function (t) {
        var slug = t[0], handle = t[1], ad = t[2], anlam = t[3];
        if (dict && dict[handle]) { ad = dict[handle][0]; anlam = dict[handle][1]; }
        if (seen[handle]) ad = seen[handle];          /* mağaza çevirisi önceliklidir */

        var a = document.createElement('a');
        a.className = 'hm-t';
        a.href = prefix + '/collections/' + handle;

        var f = document.createElement('span');
        f.className = 'hm-tf';
        var img = document.createElement('img');
        img.className = 'hm-tim';
        img.src = TAS_CDN + slug + '.png?width=88';
        img.alt = '';
        img.width = 34; img.height = 34;
        img.loading = 'lazy'; img.decoding = 'async';
        f.appendChild(img);

        var n = document.createElement('span');
        n.className = 'hm-tn';
        n.textContent = ad;

        var m = document.createElement('span');
        m.className = 'hm-tm';
        m.textContent = anlam;

        a.appendChild(f); a.appendChild(n); a.appendChild(m);
        li.appendChild(a);
      });
      ul.appendChild(li);

      promos.forEach(function (p) {
        localizeHrefs(p, prefix);   /* tema promo linkleri kök-göreli gelir → dil öneki ekle */
        p.querySelectorAll('img').forEach(function (img) {
          img.loading = 'lazy'; img.sizes = '(min-width: 990px) 560px, 1px';   /* 2026-09-28: kapalı menüde inmesin */
        });
        ul.appendChild(p);
      });
    });
  }

  /* ── Taşlar foto carousel ── */
  function initTaslar() {
    document.querySelectorAll('.navigation__tier-2-container').forEach(function (container) {
      if (!container.querySelector('a[href$="/collections/ametist-tasi"]')) return;
      if (container.dataset.hmCarousel) return;
      var promos = [].slice.call(container.querySelectorAll('li.navigation__column--promotion'));
      if (!promos.length) return;
      container.dataset.hmCarousel = '1';
      promos.forEach(function (p) {
        /* 2026-09-28: buildTaslar'daki lazy ayarını ezmesin; kapalı menüde inmesin */
        p.querySelectorAll('img').forEach(function (img) { img.loading = 'lazy'; img.sizes = '(min-width: 990px) 490px, 1px'; });
      });
      var i = 0;
      function show(n) {
        i = (n + promos.length) % promos.length;
        promos.forEach(function (p, j) { p.classList.toggle('hm-on', j === i); });
      }
      show(0);
      if (promos.length < 2) return;
      function arrow(dir) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'hm-arrow ' + (dir > 0 ? 'hm-next' : 'hm-prev');
        b.setAttribute('aria-label', dir > 0 ? T('Sonraki görsel','Next image') : T('Önceki görsel','Previous image'));
        b.innerHTML = dir > 0 ? '&#8594;' : '&#8592;';
        b.addEventListener('click', function (e) {
          e.preventDefault(); e.stopPropagation();
          show(i + dir);
        });
        return b;
      }
      container.appendChild(arrow(-1));
      container.appendChild(arrow(1));
      setInterval(function () { show(i + 1); }, 5000);
    });
  }

  /* ══ ÜST MENÜ (tier-1) BAŞLIK HEDEFLERİ — Görev 6 ══
     Shopify Navigation'da üç başlık da /collections'a bakıyor. Admin API
     token'ında `read_online_store_navigation` scope'u YOK → menü href'i
     koddan okunamıyor/yazılamıyor; burada JS ile kapı sayfalarına çevriliyor.
     Shopify menüsü fallback olarak yerinde kalır (JS düşerse eski davranış).

     Eşleştirme METNE bakmaz (TR/EN/RU/AR başlıkları farklı) — panelin
     kurulum bayrağına bakar:
       data-hm-muc → Mücevher · data-hm-tas → Taşına Göre · data-hm-burc → Burcuna Göre
     Panel kurulamamışsa (probe düşmüşse) ham tema linklerinden tespit edilir.

     Panel içeriği, hover/aria davranışı ve aria-controls DEĞİŞMEZ —
     yalnız tier-1 <a class="navigation__link"> href'i. Masaüstü + `-mob`
     drawer klonu aynı DOM desenini paylaştığı için ikisi de kapsanır. */
  var TIER1_TARGET = [
    ['data-hm-muc',  '/pages/mucevher'],
    ['data-hm-tas',  '/pages/tasina-gore'],
    ['data-hm-burc', '/pages/burcuna-gore-tasini-sec']
  ];
  /* Panel kurulmamışsa ham linklerden tanıma (sıra önemli: burç/taş önce) */
  var TIER1_RAW = [
    ['a[href*="/collections/burc-koc"]',      '/pages/burcuna-gore-tasini-sec'],
    ['a[href*="/collections/ametist-tasi"]',  '/pages/tasina-gore'],
    ['a[href*="/collections/yuzuk"], a[href*="/collections/kolye"], a[href*="/collections/tum-mucevherler"]', '/pages/mucevher']
  ];

  /* dil yolu öneki (/en, /ru, /ar).
     BİRİNCİL kaynak Shopify.routes.root — 4 dilde de doğru ('/', '/en/', '/ru/', '/ar/').
     Yedek yol (panel içi /collections/ linkinden türetme) yalnız routes.root
     yokken devreye girer; bu yüzden buildBurc() navPrefix'i ul'u temizlemeden
     ÖNCE çağırır (temizlenmiş panelde türetilecek link kalmaz). */
  function navPrefix(scope) {
    try {
      var r = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '';
      if (r) return r === '/' ? '' : r.replace(/\/+$/, '');
    } catch (e) { /* devam: yedek yola düş */ }
    var a = scope && scope.querySelector('a[href*="/collections/"]');
    if (a) {
      var h = a.getAttribute('href') || '';
      var i = h.indexOf('/collections/');
      if (i > 0) return h.slice(0, i);
    }
    /* son çare: URL'nin ilk parçası dil kodu mu? */
    var seg = (location.pathname || '/').split('/')[1] || '';
    return /^[a-z]{2}(-[a-z]{2})?$/i.test(seg) ? '/' + seg : '';
  }

  /* aria-controls anahtarı: NavigationTier2-2 · -2-mob · -2-mobMobileNav → hepsi "NavigationTier2-2" */
  function t1Key(a) {
    var id = a.getAttribute('aria-controls') || '';
    return id ? id.replace(/-mob.*$/, '') : '';
  }

  function setTier1Href(ul, path, map) {
    var item = ul.closest('li.navigation__item');           /* tier-1 <li> — masaüstü ya da drawer klonu */
    if (!item) return;
    var head = item.querySelector(':scope > a.navigation__link');
    if (!head) return;
    var href = navPrefix(ul) + path;
    if (!head.dataset.hmT1) {
      head.dataset.hmT1 = '1';
      head.setAttribute('href', href);
    }
    var k = t1Key(head);
    if (k && !map[k]) map[k] = href;
  }

  function retargetTier1() {
    var map = {};   /* aria-controls → yeni href */

    TIER1_TARGET.forEach(function (pair) {
      document.querySelectorAll('ul.navigation__tier-2[' + pair[0] + ']').forEach(function (ul) {
        setTier1Href(ul, pair[1], map);
      });
    });
    /* yedek yol: paneli kurulamamış (probe düşmüş) tier-2'ler */
    document.querySelectorAll('ul.navigation__tier-2').forEach(function (ul) {
      if (ul.dataset.hmMuc || ul.dataset.hmTas || ul.dataset.hmBurc) return;
      for (var i = 0; i < TIER1_RAW.length; i++) {
        if (ul.querySelector(TIER1_RAW[i][0])) { setTier1Href(ul, TIER1_RAW[i][1], map); return; }
      }
    });

    /* #proxy-nav (sticky başlıktaki panelsiz kopya) ve benzeri klonlar:
       kendi tier-2 paneli yok, ama aynı aria-controls id'sini taşıyor. */
    document.querySelectorAll('ul.navigation__tier-1 > li > a.navigation__link[aria-controls]').forEach(function (a) {
      if (a.dataset.hmT1) return;
      var href = map[t1Key(a)];
      if (!href) return;
      a.dataset.hmT1 = '1';
      a.setAttribute('href', href);
    });
  }

  /* ══ MOBİL DRAWER KAPI SATIRI — Görev 6 fix ══
     Tema, alt menülü bir tier-1 başlığına drawer'da basınca tıklamayı
     akordeon aç/kapa'ya çeviriyor (preventDefault) → retargetTier1 href'i
     doğru olsa bile mobilde kapı sayfalarına gidilemiyor.
     Çözüm: drawer klonundaki (tier-2 container id'si "…-mob…") üç panelin
     EN ÜSTÜNE "Panel adı →" satırı. Href + etiket doğrudan tier-1
     başlığından okunur → dil öneki ve 4 dilin çevirisi kendiliğinden gelir
     (etiket Shopify'ın çevirdiği menü metni, href retargetTier1 çıktısı).
     MASAÜSTÜ PANELLERİNE EKLENMEZ (container id'sinde "-mob" yoksa atlanır);
     CSS'te ayrıca min-width:990px'te display:none ile ikinci kapı vardır. */
  function addDrawerGates() {
    document.querySelectorAll('ul.navigation__tier-2').forEach(function (ul) {
      if (ul.dataset.hmGate) return;
      if (!(ul.dataset.hmMuc || ul.dataset.hmTas || ul.dataset.hmBurc)) return;
      var cont = ul.closest('.navigation__tier-2-container');
      if (!cont || (cont.id || '').indexOf('-mob') === -1) return;   /* yalnız drawer klonu */
      var item = ul.closest('li.navigation__item');
      var head = item && item.querySelector(':scope > a.navigation__link');
      if (!head) return;
      var href = head.getAttribute('href') || '';
      var text = (head.textContent || '').trim();
      /* retargetTier1 çalışmamışsa (href hâlâ /collections/…) satır basma */
      if (!text || href.indexOf('/pages/') === -1) return;
      ul.dataset.hmGate = '1';

      var li = document.createElement('li');
      li.className = 'hm-gate-li';
      var a = document.createElement('a');
      a.className = 'hm-gate';
      a.setAttribute('href', href);
      a.appendChild(document.createTextNode(text));
      var ar = document.createElement('span');
      ar.className = 'hm-gate-ar';
      ar.textContent = '→';
      a.appendChild(ar);
      li.appendChild(a);
      ul.insertBefore(li, ul.firstChild);
    });
  }

  function init() { buildMucevher(); buildBurc(); buildHikaye(); buildTaslar(); initTaslar(); retargetTier1(); addDrawerGates(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
